var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVoteIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 11.9279L16.5 13.5679L18.5 15.7479H5.5L7.5 13.5679L6 11.9279L3 15.1979V19.7479C3 20.8479 3.9 21.7479 5 21.7479H19C20.1 21.7479 21 20.8479 21 19.7479V15.2079L18 11.9279Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.59 14.1679C11.37 14.9579 12.64 14.9679 13.43 14.1779L18.41 9.19793C19.19 8.41793 19.19 7.14793 18.41 6.36793L14.87 2.83793C14.09 2.05793 12.82 2.05793 12.04 2.83793L7.09 7.78793C6.31 8.56793 6.31 9.81793 7.08 10.6079L10.59 14.1679ZM13.46 4.24793L16.99 7.77793L12.05 12.7179L8.52 9.18793L13.46 4.24793Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVoteIcon);
export default __webpack_public_path__ + "static/media/VoteIcon.912c4acdae3c139a02a2ebbb537886b0.svg";
export { ForwardRef as ReactComponent };